const reducerName = '@cityoo-tenant/map/territories-boundaries';

export const RESET = `${reducerName}/RESET`;

export const GET_TERRITOTIES_BOUNDARIES_START = `${reducerName}/GET_TERRITOTIES_BOUNDARIES_START`;
export const GET_TERRITOTIES_BOUNDARIES_SUCCESS = `${reducerName}/GET_TERRITOTIES_BOUNDARIES_SUCCESS`;
export const GET_TERRITOTIES_BOUNDARIES_FAIL = `${reducerName}/GET_TERRITOTIES_BOUNDARIES_FAIL`;
